class GridSwitcher extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll('span');
    this.input = this.querySelector('input');

    GridSwitcher.updateGridItems();
  }
  connectedCallback() {
    this.buttons.forEach(button => button.addEventListener('click', (event) => {
      const value = event.target.dataset.value;
      this.input.value = value

      sessionStorage.setItem('grid-switcher', value);
      event.target.classList.add('tw-hidden')
      this.querySelector('span:not([data-value="' + value + '"])').classList.remove('tw-hidden')
      GridSwitcher.updateGridItems();
    })
    )
  }

  static updateGridItems() {
    // Update grid items
    const grid = sessionStorage.getItem('grid-switcher');
    const input = document.getElementById('grid-switcher');
    let defaultValue = 4
    if(grid) {
      defaultValue = grid
      const gridMobile = grid / 4
      
      const producGridClasses = document.getElementById('product-grid').classList
      const gridClassMobile = Array.from(producGridClasses).filter(elem => elem.includes('-col-tablet-down'));
      if(gridClassMobile.length)
        producGridClasses.replace(gridClassMobile[0], `grid--${gridMobile}-col-tablet-down`)

      const gridClass = Array.from(producGridClasses).filter(elem => elem.includes('-col-desktop'));
      if(gridClass.length)
         producGridClasses.replace(gridClass[0], `grid--${grid}-col-desktop`)
    } else {
      if (new DeviceWidth().isMobile) {
        defaultValue = 8;
      }
    }
    input.value = defaultValue
    document.querySelector('.grid__switcher span[data-value="' + defaultValue + '"]').classList.add('tw-hidden')
    document.querySelector('.grid__switcher span:not([data-value="' + defaultValue + '"])').classList.remove('tw-hidden')
  }
}

if (!customElements.get('grid-switcher')) {
  customElements.define('grid-switcher', GridSwitcher);
}
